import React from "react";
import { Radio } from "antd";
import { useTranslation } from 'react-i18next';
import { Wrapper } from "./styles";

const SelectComponent = ({ values, defaultValue, callback }) => {

  const { t } = useTranslation();

  return (
    <Wrapper>
      <Radio.Group value={defaultValue} onChange={callback}>
        {values &&
          values.map(value => (
            <Radio.Button key={value.key} value={value.key}>
              {t('labels.'+value.value)}
            </Radio.Button>
          ))}
      </Radio.Group>
    </Wrapper>
  );
};
export default SelectComponent;
